import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import withStyles from 'isomorphic-style-loader/withStyles';
import icons from 'config/icons';
import Link from 'components/link';

import styles from './editionPickerDropdown.css';

class EditionPickerDropdown extends Component {
  state = {
    expanded: false,
  };

  hide = () => {
    this.setState({ expanded: false });
  };

  toggle = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  // react-onclickoutside requires this method be defined
  handleClickOutside = () => {
    this.hide();
  };

  render() {
    const { editions, selectedEdition } = this.props;

    return (
      <div>
        <button
          className={styles.toggle}
          onClick={this.toggle}
        >
          <span>{selectedEdition}</span>
          <img
            alt="Expand SubNav"
            src={icons.downArrow}
            height="4"
            width="8"
          />
        </button>
        {this.state.expanded &&
          <ul className={styles.list}>
            {Object.keys(editions).map((languageCode) => {
              const currentEdition = editions[languageCode];

              return (
                <li
                  key={currentEdition.name}
                  className={styles.item}
                >
                  <Link
                    className={styles.link}
                    to={currentEdition.link}
                    onClick={this.hide}
                  >
                    <span>{currentEdition.name}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        }
      </div>
    );
  }
}

EditionPickerDropdown.propTypes = {
  selectedEdition: PropTypes.string.isRequired,
  editions: PropTypes.object.isRequired,
};

const wrapWithStyles = withStyles(styles);

export default wrapWithStyles(onClickOutside(EditionPickerDropdown));
